import { createGlobalStyle } from 'styled-components';
import CONSTANTS from 'app/CONSTANTS';

const GlobalStyle = createGlobalStyle`
    #ace_settingsmenu {
        background-color: ${CONSTANTS.MAIN_COLOR};
        font-family: -apple-system,BlinkMacSystemFont,segoe ui,pingfang sc,hiragino sans gb,microsoft yahei,helvetica neue,Helvetica,Arial,sans-serif,apple color emoji,segoe ui emoji,segoe ui symbol;
        & td {
            color: #fff;
        }

        & td div {
            color: #000000a6;
        }

        & button {
            color: #000000a6;
        }

        & input[type="number"] {
            height: 18px;
            margin-right: 4px;
            margin-bottom: 8px;
            padding: 4px 10px;
            background-color: #fff;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            position: relative;
            top: 2px;
            color: #000000a6;
        }

        & input[type="checkbox"] {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            background-color: #fff;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            padding: 9px !important;
            border-radius: 3px;
            display: inline-block;
            position: relative;
            background-image: none;
            margin-right: 4px;
            margin-bottom: 18px;
            position: relative;
            top: 10px;
            color: #000000a6;
        }

        & input[type="checkbox"]:checked {
            background-color: #fff;
            border: 1px solid #adb8c0;
            color: #99a1a7;
        }

        & input[type="checkbox"]:checked:after {
            content: "\\2714";
            font-size: 14px;
            position: absolute;
            top: 0px;
            left: 3px;
            color: #99a1a7;
        }

        & label {
            color: #fff;
        }

        & .ace_optionsMenuEntry button {
            height: 32px;
            border: 1px solid #d9d9d9;
            border-right: none;
            border-top-width: 1.02px;
            margin-bottom: 8px;
        }

        & .ace_optionsMenuEntry div[aria-labelledby=keyboardHandler-label] button:first-child {
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }
        & .ace_optionsMenuEntry div[aria-labelledby=keyboardHandler-label] button:last-child {
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
        }
        & .ace_optionsMenuEntry div[aria-labelledby=wrap-label] button:first-child {
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }
        & .ace_optionsMenuEntry div[aria-labelledby=wrap-label] button:last-child {
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
        }
        & .ace_optionsMenuEntry div[aria-labelledby=scrollPastEnd-label] button:first-child {
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }
        & .ace_optionsMenuEntry div[aria-labelledby=scrollPastEnd-label] button:last-child {
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
        }

        & .ace_optionsMenuEntry:nth-child(4) button:nth-child(2) {
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }
        & .ace_optionsMenuEntry:nth-child(4) > td button:last-child {
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
        }

        & .ace_optionsMenuEntry button[ace_selected_button=true] {
            box-shadow: none;
        }

        & select {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            background-image: url(/static/images/icons/fieldlet-trigger-combo.svg);
            background-repeat: no-repeat;
            background-position-x: 96%;
            background-position-y: 8px;
            background-size: 12px
            height: 32px;
            border: 1px solid #d9d9d9;
            border-top-width: 1.02px;
            border-radius: 4px;
            outline: none;
            cursor: pointer;
            margin-bottom: 8px;
            padding-left: 10px;
            width: 100%;
            color: #000000a6;
            font-size: 14px;
        }
    }

`;
export default GlobalStyle;
